export function arrayIncludesObject(
  array: { [key: string]: any }[],
  object: { [key: string]: any }
): boolean {
  return array.some((item) => JSON.stringify(item) === JSON.stringify(object));
}
